import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { ScoringTypeEnum } from 'src/app/shared/config/questions.config';
import { customValidationService } from 'src/app/shared/custom.validator';
import { CollectionService } from '@services/collection.service';
// export function spaceValidator(control: AbstractControl) {
//   if (control && control.value && !control.value.replace(/^\s+|\s+$/g, '').length) {
//       control.setValue('');
//       return { required: true }
//   }
//   else {
//       return null;
//   }
//   }
@Component({
  selector: 'app-tests-create',
  templateUrl: './tests-create.component.html',
  styleUrls: ['./tests-create.component.scss'],
})
export class TestsCreateComponent implements OnInit {
  basicDetailsForm: FormGroup;
  globalcollectionuuid: any;
  duplicateDataFlag = false;
  collectionuuid: number;
  ScoringTypeEnum = ScoringTypeEnum;
  isStyleGroupShow = false;
  scoringTypes: any;
  scoringTypeId: any;
  styleGroupData: any;
  selectedScoringType: any;
  evaluationMode: number;

  constructor(
    private testService: TestService,
    private fb: FormBuilder,
    private router: Router,
    private routerstate: ActivatedRoute,
    private messageService: MessageService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<TestsCreateComponent>,
    public CollectionService: CollectionService,

  ) {   }

  ngOnInit(): void {
    this.scoringTypeId = JSON.parse(sessionStorage.getItem('scoringTypeId'));
    const userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.evaluationMode = userData.evaluationmode;

    this.globalcollectionuuid = JSON.parse(
      sessionStorage.getItem('defaultcollectionuuid')
    );
    // this.collectionuuid = this.globalcollectionuuid.replace(/['"]+/g,'')

    this.testService.getScoringTypes().subscribe((scoringTypes) => {
      if(this.evaluationMode === 1){
        this.scoringTypes = scoringTypes.items.filter(type => type.scoringTypeId === 1 || type.scoringTypeId === 2);
      } else {
        this.scoringTypes = scoringTypes.items;
      }
    });

    this.basicDetailsForm = new FormGroup({
      testTitle: new FormControl(null, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/),
        customValidationService.cannotContainSpace
      ]),
      testDescription: new FormControl(
        '',
        [
          Validators.minLength(1),
          Validators.maxLength(480),
        ]
      ),
      scoringTypeId: new FormControl(this.scoringTypeId, [Validators.required]),
      styleGroupId: new FormControl('')
    });

    if (this.scoringTypeId != null) {
      this.selectedScoringType = this.scoringTypeId;
      if (this.scoringTypeId === 3) this.changeScoringType(this.scoringTypeId);
    }

    this.testService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
      this.styleGroupData = data.data;
      // this.testService.styleGroup.next(data.data);
    });
  }

  // This function used for validation purpose
  get f() {
    return this.basicDetailsForm.controls;
  }

  changeScoringType(event) {
    this.isStyleGroupShow = parseInt(event) == 3 ? true : false;
    const styleGroupId = this.basicDetailsForm.get('styleGroupId');

    if (parseInt(event) != 0) {
      if (parseInt(event) === 3) {
        styleGroupId.setValidators([Validators.required]);
      } else {
        styleGroupId.setValue('');
        styleGroupId.setValidators(null);
        styleGroupId.markAsUntouched();
      }
      styleGroupId.updateValueAndValidity();
    }
  }

  saveBasicTestDetails() {
    if (this.basicDetailsForm.value.testDescription != null) {
      this.basicDetailsForm.value.testDescription =
        this.basicDetailsForm.value.testDescription.trim();
    } else {
      this.basicDetailsForm.value.testDescription =
        this.basicDetailsForm.value.testDescription;
    }
    const apiData = {
      collectionuuId: this.globalcollectionuuid,
      testTitle: this.basicDetailsForm.value.testTitle.trim(),
      testDescription: this.basicDetailsForm.value.testDescription,
      scoringTypeId: this.basicDetailsForm.value?.scoringTypeId,
      StyleGroupID: this.basicDetailsForm.value?.styleGroupId
    };

    this.testService.createTest(apiData).subscribe(
      (testData) => {
        if (testData?.data.testId) {
          this.testService.testDetails.next(testData);
          this.testService.getTests(this.globalcollectionuuid).subscribe(testData => {
            this.testService.newTestList(testData);
          },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error);
          });
          this.notificationService.success(testData?.message);
          // this.router.navigate(['../tests', testData?.data.testuuId], {
          //   relativeTo: this.routerstate,
          // });
          this.dialogRef.close();
        }
      },
      (error) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        // if (error.error.error == 'Conflict') {
        //   this.duplicateDataFlag = true;
        // }
        this.basicDetailsForm.controls['testTitle'].reset()
      }
    );
  }

  onTestNameControlFocus(): void {
    this.duplicateDataFlag = false;
  }
}
